<div style="padding: 15px;">
    <div class="col-md-12 col-12 col-xs-12">
        <div class="row">
            <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                <h4 class="modal-title">
                    <div style="display: flex; flex-direction: column;">
                        <span style="color: #777; font-size: 14px;">Start Stage</span>
                        <h4 style="display: inline-block;font-size: 1.4rem; margin-bottom: 0px;">{{stage.stageName}}</h4>  
                    </div>
                </h4>
            </div>
            <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal('')"></i>
            </div>
        </div>
    </div>

    <div>
        <div class="col-md-12 col-12 col-sm-12 pad0" style="margin-top: 10px; display:  none;" >
            <span style="font-size: 13px;">
                Stage
            </span>
            <div>
                <select class="form-control formCtlFltr brdrFocus" style="background-color: inherit; cursor: pointer; width: 200px; margin-top: 5px; border: 1px solid #BCC2C9;" [(ngModel)]="stage.sid">
                    <option value="" selected>Select</option>
                    <option *ngFor="let s of stages" [ngValue]="s.SID">{{s.SNm}}</option> 
                </select>                        
            </div>
        </div>

        <div class="col-md-12 col-12 col-sm-12 pad0" style="margin-top: 10px;">
            <span style="font-size: 13px;">
                Target
            </span>
            <div>
                <input matInput readonly (click)="picker.open()" (focus)="picker.open()" [matDatepicker]="picker" [min]="todayDate" class="form-control formCtlFltr bgwhite brdrFocus brdrColor" [(ngModel)]="stage.target" style="display: inline-block; outline: none !important; cursor: pointer; font-size: 13px; width: 90px; margin-top: 5px; padding-left: 6px; font-size: 12px; border: 1px solid #BCC2C9;">
                <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
            </div>  
        </div>
        

        <div class="col-md-12 col-12 col-sm-12 pad0" style="margin-top: 10px;">
            <span style="font-size: 13px;">
                Instructions
            </span>
            <textarea rows="3"  maxlength="200" [(ngModel)]="stage.instruction" class="form-control brdrColor brdrRadius3" style="font-size: 13px; resize: none; margin-top: 5px; width: 100%; outline: none; padding: 4px 8px; font-size: 12px; border: 1px solid #BCC2C9;"></textarea>
        </div>

        <div class="col-md-12 col-12 col-sm-12 pad0" style="margin-top: 10px;">
            <div (click)="addStage()" class="btn btn-darkGreen brdrRadius3" style="padding: 3px 8px 3px; font-size: 13px; line-height: 1.66em;">
                <i class="zmdi zmdi-check" style="margin-right: 5px;"></i> Save
            </div>
        </div>
    </div>
</div>